import { useMutation } from '@tanstack/react-query'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'

type PlanDiscountCalculation = {
  services?: number[]
  planId?: number
  paymentPeriod?: string
  coverageId: number
}
export const planDiscountCalculation = async (data: PlanDiscountCalculation) => {
  return axios.post(endpoints.planDiscountCalculation, data)
}
export const usePlanDiscountCalculation = () => {
  return useMutation(planDiscountCalculation)
}
